// src/supabaseClient.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://ecgrpuypfisnevshmlol.supabase.co";
const supabaseKey = "sb_publishable_vEoStFMI_ducYTlKLA0LfA__6mVThe-";

export const supabase = createClient(supabaseUrl, supabaseKey);
